import { defineMessages } from 'react-intl';

export default defineMessages({
  productName: {
    id: 'Pdp.buyMoreSaveMore.productTitle',
    description: 'Title for product',
    defaultMessage: 'Product: ',
  },
  color: {
    id: 'Pdp.buyMoreSaveMore.color',
    description: 'Title for the color selector',
    defaultMessage: 'Color: ',
  },
  noDiscountMessage: {
    id: 'Pdp.buyMoreSaveMore.noDiscountMessage',
    description: 'Regular Price Text',
    defaultMessage: 'Regular Price',
  },
  addAnotherItemSave: {
    id: 'Pdp.buyMoreSaveMore.addAnotherItemSave',
    description: 'Add another item to save more text',
    defaultMessage: 'Add another item and get {discountPercentage}% off',
  },
  maxDiscount: {
    id: 'Pdp.buyMoreSaveMore.maxDiscount',
    description: 'Maximum discount text',
    defaultMessage: 'You\'re saving {discountPercentage}% on accessories!',
  },
  discountBadge: {
    id: 'Pdp.buyMoreSaveMore.discountBadge',
    description: 'Discount Badge Text',
    defaultMessage: '{discountPercentage}% off',
  },
  totalPrice: {
    id: 'Pdp.buyMoreSaveMore.totalPrice',
    description: 'Total Price Text',
    defaultMessage: 'Total Price',
  },
  oneItem: {
    id: 'Pdp.buyMoreSaveMore.oneItem',
    description: '1 Item Text',
    defaultMessage: '1 Item',
  },
  manyItems: {
    id: 'Pdp.buyMoreSaveMore.manyItems',
    description: 'Items Text',
    defaultMessage: '{count} Items',
  },
  maxItems: {
    id: 'Pdp.buyMoreSaveMore.maxItems',
    description: 'Maximum Item Discount Tier',
    defaultMessage: '{count}+ Items',
  },
  addToCartSingleItem: {
    id: 'Pdp.buyMoreSaveMore.button.singleItem.text',
    defaultMessage: 'Add selected to Cart',
  },
  addToCartMultipleItems: {
    id: 'Pdp.buyMoreSaveMore.button.multipleItems.text',
    defaultMessage: 'Add Items to Cart',
  },
  continueToCart: {
    id: 'Pdp.buyMoreSaveMore.button.continueToCart',
    defaultMessage: 'Continue to Cart',
  },
});
